import apiClient from './apiClient';

/**
 * Fetches the active list of colleges
 * @returns {Promise<Object>} The API response with college list
 */
export const getActiveColleges = async (search = '') => {
    try {
        const response = await apiClient.get(`/colleges/active-list${search ? `?search=${search}` : ''}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
/**
 * Fetches college details with its trades
 * @param {string|number} collegeId - The ID of the college
 * @returns {Promise<Object>} The API response with college and trades
 */
export const getCollegeWithTrades = async (collegeId) => {
    try {
        const response = await apiClient.get(`/colleges/${collegeId}/with-trades`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
